import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services';
import { environment } from "../environments/environment";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        var currentTime = new Date().getTime();
        var token = null;
        if(localStorage.getItem('token')!=undefined){
            token = localStorage.getItem('token');
        }

        if(request.url.includes('tenants/basic-info/')){
            request = request.clone({
                headers: new HttpHeaders({
                })
            });
        }
        else if(request.url.includes('/itc/gpms/opera/folio/settle-with-points/')){
            const otp = localStorage.getItem('verifyotp');
            request = request.clone({
                headers: new HttpHeaders({
                    'Cache-control': "private",
                    'gravty_program_id': '17',
                    'x-gpms-otp': otp
                })
            });
        }
        else if(request.url.includes('/itc/gpms/')){
            request = request.clone({
                headers: new HttpHeaders({
                    'gravty_program_id': '17',
                    'Cache-control': "private"
                })
            });
        }
        else
        {
            request = request.clone({
                headers: new HttpHeaders({
                    'Authorization':  'JWT '+ token,
                })
            });
        }
        return next.handle(request);
    }
}